import { wsClient } from '@/services/webSocket'
import { OFFER_SCHEDULE_UPDATE_SUBSCRIPTION, MUTATION_UPSERT_SALES_CAMPAIGN } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { clearInterval } from 'timers'
import Swal from 'sweetalert2'

export const tradeCampaignProcessing = {
  data: () => ({
    timerPartialValue: 0,
    errorOnSave: false,
    interval: null,
    newOfferScheduleIdToCompare: null,
    timerTotalValue: 0,
  }),
  watch: {
    timerTotalValue: {
      handler(value) {
        if (value > 0) {
          this.initTimer()
        }
      },
    },
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  computed: {
    timerLabel() {
      const timeRemaining = this.timerTotalValue - this.timerPartialValue
      const seconds = timeRemaining === 1 ? 'segundo restante' : 'segundos restantes'
      return `${timeRemaining} ${seconds}`
    },
  },
  methods: {
    initTimer() {
      this.interval = setInterval(() => {
        if (this.timerPartialValue < this.timerTotalValue) this.timerPartialValue++
      }, 1000)
    },

    async subscribeToOfferSchedule() {
      const self = this
      await wsClient.subscribe(
        {
          query: OFFER_SCHEDULE_UPDATE_SUBSCRIPTION,
          operationName: 'OffersScheduleUpdate',
        },
        {
          next({ data: { offersScheduleUpdate } }) {
            const { offerScheduleId, status } = offersScheduleUpdate
            if (status === 'SUCCESS' && offerScheduleId === self.newOfferScheduleIdToCompare) {
              self.loading = false
              self.onSubscriptionSuccess()
            }
            if (status === 'ERROR' && offerScheduleId === self.newOfferScheduleIdToCompare) {
              self.errorOnSave = true
              self.loading = false
              self.onSubscriptionError()
            }
          },
          error(error) {
            console.error(error)
            self.errorOnSave = true
            self.loading = false
          },
        }
      )
    },

    async processCampaign(campaignToSave, errorMessage = 'Erro ao processar operação') {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_UPSERT_SALES_CAMPAIGN,
          variables: {
            data: campaignToSave,
          },
        })

        const { process_time_estimation, _id } = data.upsertOfferSchedule

        this.newOfferScheduleIdToCompare = _id
        this.timerTotalValue = process_time_estimation

        if (process_time_estimation > 0) {
          this.onSubscriptionStart()
        }
      } catch (err) {
        console.log(err)
        this.showErrorMessage(errorMessage)
      }
    },

    // Métodos que podem ser sobrescritos pelos componentes
    onSubscriptionStart() {},
    onSubscriptionSuccess() {},
    onSubscriptionError() {},
    onClose() {},

    showSuccessMessage(message) {
      Swal.fire({
        text: message,
        icon: 'success',
        showConfirmButton: false,
        timer: 1000,
        onClose: () => {
          this.onClose()
        },
        customClass: {
          content: 'content-class',
        },
      })
    },

    showErrorMessage(message) {
      Swal.fire({
        text: message,
        icon: 'error',
        showConfirmButton: false,
        timer: 1000,
        customClass: {
          content: 'content-class',
        },
      })
    },
  },
}
